import * as React from 'react';

const DisappointedSmileIcon = (props) => (
  <svg
    width={75}
    height={67}
    viewBox="0 0 75 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M24.5863 28.3105C21.9257 28.3105 20.1519 26.484 20.1519 23.7443V4.56621C20.1519 1.82648 21.9257 0 24.5863 0C27.247 0 29.0207 1.82648 29.0207 4.56621V23.7443C29.0207 26.0274 26.8035 28.3105 24.5863 28.3105ZM53.8534 23.7443V4.56621C53.8534 1.82648 52.0797 0 49.419 0C46.7584 0 44.9846 1.82648 44.9846 4.56621V23.7443C44.9846 26.484 46.7584 28.3105 49.419 28.3105C52.0797 28.3105 53.8534 26.0274 53.8534 23.7443ZM7.73558 64.3836C12.6134 56.1644 24.5863 50.6849 37.4461 50.6849C49.8625 50.6849 61.3919 55.7078 66.7132 63.4703C68.0435 65.7534 70.7042 66.21 72.9214 64.8402C75.1386 63.4703 75.582 60.7306 74.2517 58.4475C67.1566 47.9452 53.41 41.5525 37.8895 41.5525C21.4822 41.5525 6.8487 48.8584 0.640526 59.8173C-0.689797 62.1005 0.197085 64.8402 1.97085 66.21C2.85773 66.6667 3.30117 66.6667 4.18805 66.6667C5.07493 66.6667 6.8487 65.7534 7.73558 64.3836Z" />
  </svg>
);
export default DisappointedSmileIcon;
